import script from "./iccidadd.vue?vue&type=script&lang=ts&setup=true"
export * from "./iccidadd.vue?vue&type=script&lang=ts&setup=true"

import "./iccidadd.vue?vue&type=style&index=0&id=9f8c1158&lang=scss"

const __exports__ = script;

export default __exports__